import React, { useEffect, useState } from 'react';
import getResults from 'services/ProductsManager/Results';

import { Container, BoxREsults, Card } from './styles';
import { getNameMonph } from './getNameMonph';
import { formatarMoedaBRL } from './masks';
import Carroussel from './Carrousel/index';

interface Item {
  value: string;
  label: string;
}

interface FiltersOptions {
  directory?: Item[];
  region?: Item[];
  channel?: Item[];
  uf?: Item[];
}

interface Campaign {
  id: number;
  isTerraBrasil: boolean;
  label: string;
}

interface Props {
  Products: Item;
  Filters: FiltersOptions;
  Campaign: Campaign[];
  initialCampaign?: number;
  borderColor: string;
  color: string;
}

interface monph {
  ano: string;
  mes: string;
  nome_mes: string;
  total: number;
}

interface ResultsData {
  count_register: number;
  valor_medio: number;
  volum_total: string;
  soma: string;
  meses: monph[];
}

const Producer: React.FC<Props> = ({
  Products,
  Filters,
  Campaign,
  initialCampaign = 0,
  borderColor,
  color
}) => {
  const [countRegister, setCountRegister] = useState<number>();
  const [valorMedio, setValorMedio] = useState<number>();
  const [volumTotal, setVolumTotal] = useState<string>();
  const [soma, setSoma] = useState<string>();
  const [firstMeses, setfirstMeses] = useState<string>('');
  const [secuntMeses, setSecuntMeses] = useState<string>('');
  const [filterSafra, setFilterSafra] = useState<number>(initialCampaign);
  const [loading, setLoading] = useState<any>(false);

  useEffect(() => {
    const loadLink = async () => {
      const responseData: ResultsData = await getResults(
        Products?.value || '',
        Filters,
        filterSafra,
      );

      setCountRegister(responseData.count_register);
      setValorMedio(responseData.valor_medio);
      setVolumTotal(responseData.volum_total);
      setSoma(responseData.soma);
      setfirstMeses(responseData.meses?.[0]?.mes || '');
      setSecuntMeses(responseData.meses?.[1]?.mes || '');

      setLoading(true);
    };
    loadLink();
  }, [Products, Filters, filterSafra]);

  const teste = (firstMeses: string | '', secuntMeses: string | '') => {
    const nameFirstMonth = getNameMonph(parseInt(firstMeses, 10));
    const nameSecondMonth = getNameMonph(parseInt(secuntMeses, 10));

    if (nameFirstMonth && nameSecondMonth) {
      return `${nameFirstMonth} E ${nameSecondMonth}`;
    } else if (nameFirstMonth) {
      return nameFirstMonth;
    } else if (nameSecondMonth) {
      return nameSecondMonth;
    } else {
      return '';
    }
  };

  return (
    loading && (
      <Container>
        <Carroussel
          options={Campaign}
          initialCampaignId={filterSafra}
          onCampaignIdChange={(id: number) => {
            setFilterSafra(id);
          }}
        />
        <BoxREsults>
          <Card borderColor={borderColor} color={color}>
            <div className={'title'}>
              <p>
                Período de maior
                <br />
                incidência de compra
              </p>
            </div>
            <div className={'body'}>
              <h3>{teste(firstMeses, secuntMeses)}</h3>
            </div>
          </Card>
          <Card borderColor={borderColor} color={color}>
            <div className={'title'}>
              <p>Total de Produtores</p>
            </div>
            <div className={'body'}>
              <p>{countRegister}</p>
            </div>
          </Card>
          <Card borderColor={borderColor} color={color}>
            <div className={'title'}>
              <p>Preço Médio (R$)</p>
            </div>
            <div className={'body'}>
              <p>{formatarMoedaBRL(valorMedio)}</p>
            </div>
          </Card>
          <Card borderColor={borderColor} color={color}>
            <div className={'title'}>
              <p>Volume Total (Kg/L)</p>
            </div>
            <div className={'body'}>
              <p>{formatarMoedaBRL(volumTotal)}</p>
            </div>
          </Card>
          <Card borderColor={borderColor} color={color}>
            <div className={'title'}>
              <p>Valor Total (R$)</p>
            </div>
            <div className={'body'}>
              <p>{formatarMoedaBRL(soma)}</p>
            </div>
          </Card>
        </BoxREsults>
      </Container>
    )
  );
};

export default Producer;
